import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { reduxForm } from 'redux-form';
import { ADMIN_ROOT } from 'common/variables';

import PAPEditReviewSection from 'pap/components/review_editor';
import { fetchCountriesIfNeeded } from 'common/ducks/user';
import { fetchProject } from 'project/ducks/project';
import { updateProjectRequest, updateAttachments, fetchAttachments, updateBriefRequest }
  from 'pap/ducks/project';
import { displayFullScreen, hideFullScreen, cancelEditReviewSection } from 'pap/ducks/workflow';
import { updateFeaturesRequest, updateAwardsRequest } from 'pap/ducks/pricing';
import { fetchCustomContracts, createCustomContractRequest, deleteCustomContractRequest }
  from 'common/ducks/contract';
import { fetchMessagesIfNeeded } from 'common/ducks/message';
import { getProjectIdFromUrl } from 'project/utils';
import { get1to1AwardFromForm } from 'pap/utils';
import { setBannerError } from 'error';
import { adminUpdateBrief } from 'admin/ducks/projects';

export function mapStateToProps(state, { params, location }) {
  const formValues = state.form.pap_review ? state.form.pap_review.values || {} : {};
  const packages = state.pap.pricing.packages;
  const workflow = state.pap.workflow;
  const selectedPackage = (packages || []).find(p => p.id == formValues.package);

  /* this component may be either in PAP or in the project page (brief updates),
     so we need to handle the extraction of the project ID from the URL in both cases */
  let projectID = params.projectID || params.projectId; // PAP URL
  let isProjectPage = false;
  if (!projectID) {
    projectID = getProjectIdFromUrl(params); // project page URL
    isProjectPage = true;
  }

  const isAdmin = location.pathname.indexOf(ADMIN_ROOT) !== -1;

  /* initialize the form if editing a section */
  let initialValues = {};
  if (workflow.editReviewSection) {
    initialValues = { ...workflow.editReviewSection.value };
  }

  return {
    user: state.user,
    packages,
    countries: state.user.countries,
    workflow,
    projectID,
    isProjectPage,
    projectData: state.pap.project.projectData,
    initialValues,
    selectedPackage,
    customContract: state.contract.customContracts.find(c => c.type === 'ica'),
    attachments: state.pap.project.attachments,
    awardValue1to1: get1to1AwardFromForm(formValues, selectedPackage),
    isAdmin,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    adminUpdateBrief,
    updateProjectRequest,
    displayFullScreen,
    hideFullScreen,
    updateFeaturesRequest,
    updateAwardsRequest,
    updateAttachments,
    fetchCountriesIfNeeded,
    fetchCustomContracts,
    fetchProject,
    fetchAttachments,
    fetchMessagesIfNeeded,
    updateBriefRequest,
    createCustomContractRequest,
    deleteCustomContractRequest,
    cancelEditSection: cancelEditReviewSection,
    setBannerError
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'pap_review',
  })(PAPEditReviewSection)
), { withRef: true });



// WEBPACK FOOTER //
// ./pap/containers/review_editor.jsx